/**
 * Created by Reda on 17.08.2026
 */

cleverapps.SkinManager.SKINS.autumn26_expedition = {
    bundle: "expedition_autumn26",

    slots: {
        ...cleverapps.SkinManager.SKINS.rose_energy.slots,

        gameAudio: function () {
            return bundles.expedition_autumn26.urls.autumn26_music;
        },

        unitOnCell: function () {
            return cleverapps.styles.UnitOnCellExpedition;
        },

        gameSceneBg: function () {
            return {};
        },

        showOneIngredientLeft: function () {
            return true;
        },

        fogAsColorForUnits: function () {
            return cleverapps.styles.autumn26.fogAsColorForUnits;
        },

        customerInfoViewFont: function () {
            return cleverapps.styles.FONTS.EXPEDITION_CUSTOMER_INGREDIENT_INFOVIEW;
        },

        getPoiAnimation: function () {
            return "idle_fog";
        },

        showFullStateAnimationForPoi: function (unit) {
            return unit && unit.code && ["rpcustomermain0", "rpcustomermain1", "rpproducer1"].includes(unit.code);
        },

        unitFogAnimation: function () {
            return "idle_fog";
        },

        ruinsWindow: function () {
            return {
                bundle: "ruinswindow_autumn26",
                dictionaryKey: "RuinsWindow.autumn26.",
                person: {
                    role: "elf"
                }
            };
        },

        CustomerInfoViewIconScale:function () {
            return 1;
        },

        fogBlocker: function () {
            return cleverapps.styles.FogLockView.expedition;
        },

        feed_icon_png: bundles.merge_autumn26.frames.autumn26_feed_icon_png,
        wand_icon_png: bundles.merge_autumn26.frames.autumn26_wand_icon_png,

        whirlwind: bundles.fog_animations.jsons.autumn26_whirlwind,

        merge_wand_png: bundles.menubar.frames.autumn26_merge_wand_png,

        expedition_buildpass_icon_json: bundles.sidebar.jsons.autumn26_expedition_buildpass_icon_json,

        reward_wand_png: bundles.reward_icons_merge_autumn26.frames.autumn26_reward_wand_png,
        reward_wand_small_png: bundles.reward_icons_merge_autumn26.frames.autumn26_reward_wand_small_png,

        snail_feast_icon_json: bundles.sidebar.jsons.autumn26_snail_feast_icon_json,
        snailhouse_offer_json: bundles.sidebar.jsons.autumn26_snailhouse_offer_json,
        snailhouse_offer_extrabar_icon: bundles.extrabar && bundles.extrabar.jsons.autumn26_snailhouse_offer_extrabar_icon,
        snail_feast_icon: bundles.reward_icons_merge_autumn26.frames.autumn26_snail_feast_icon,

        pass_star_png: bundles.reward_icons_pass.frames.autumn26_pass_star_png,

        fog_disappear_effect: function () {
            return bundles.fog_autumn26.urls.open_effect;
        },
        unitGroundHighlight: function () {
            return false;
        },
        expeditionWandsGuideWindowStyles: function () {
            return cleverapps.styles.autumn26.expeditionWandsGuideWindow;
        }
    }
};
